import { boolean, object, string } from "yup";

import { ENTITY_TAX_INFORMATION_DEFAULT_VALUES } from "@/features/entity-tax-information";
import { StatusEnum } from "../../shared";

export const DEFAULT_VALUES = {
  name: "",
  status: StatusEnum.ACTIVE,
  ...ENTITY_TAX_INFORMATION_DEFAULT_VALUES,
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  status: boolean().required("Harus diisi"),
  defaultTaxIncluded: boolean().required("Harus diisi"),
});
